/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import { colors, sizes } from '@smartsheet/lodestar-core';
import { ArrowDownIcon, ArrowRightIcon } from '@smartsheet/lodestar-icons';
import { useState } from 'react';
import { Collapse } from 'react-collapse';
import { useTranslation } from 'react-i18next';
import { Column } from '../../../../../common/Column';
import { IconButtonNoSpacing } from '../../../../../common/IconButton/';
import KebabMenu from '../../KebabMenu/KebabMenu';
import { copyJSONSource, copyReference } from '../../data';
import { Print } from './Print';

export const ObjectHeader = ({
  name,
  obj,
  path,
}: {
  name: string;
  obj: { [key: string]: any };
  path: string;
}) => {
  const { t: translate } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const toggleHeader = () => setIsOpen(!isOpen);

  const refMenuContainerDisplayPropertyName =
    '--refMenuContainerDisplayPropertyName';
  const containerStyle = css`
    display: flex;
    align-items: center;
    height: 28px;
    :hover {
      background: ${colors.neutralLight20};
      ${refMenuContainerDisplayPropertyName}: flex;
      background-clip: content-box;
    }
    justify-content: space-between;
    padding-right: ${sizes.large}px;
  `;

  const nameStyle = css`
    font-weight: 600;
    font-size: 13px;
    line-height: 18px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  `;
  const headerTypeStyle = css`
    font-style: italic;
    font-weight: 400;
    line-height: 18px;
    color: ${colors.neutralDark30};
  `;
  const leftColumnStyle = css`
    width: calc(100% - ${sizes.xxLarge * 2}px);
  `;
  const rightColumnStyle = css`
    display: var(${refMenuContainerDisplayPropertyName}, none);
    justify-content: center;
  `;
  return (
    <div>
      <div css={containerStyle}>
        <Column css={leftColumnStyle}>
          <IconButtonNoSpacing
            onClick={toggleHeader}
            appearance="borderless"
            aria-label={
              isOpen
                ? translate('designer:runLog.collapse')
                : translate('designer:runLog.expand')
            }
          >
            {isOpen ? (
              <ArrowDownIcon
                css={css`
                  margin-right: 8.5px;
                `}
              />
            ) : (
              <ArrowRightIcon
                css={css`
                  margin-right: 8.5px;
                `}
              />
            )}
          </IconButtonNoSpacing>
          <div css={nameStyle}>
            {name}: <span css={headerTypeStyle}>Object</span>
          </div>
        </Column>
        <Column css={rightColumnStyle} width="28px">
          <KebabMenu
            id={name}
            items={[
              {
                title: translate('designer:runLog.kebabMenu.copyDataRef'),
                onClick: copyReference(path),
              },
              {
                title: translate('designer:runLog.kebabMenu.copyJSONSource'),
                onClick: copyJSONSource(obj),
              },
            ]}
            menuArialabel={translate('designer:runLog.kebabMenu.menuArealabel')}
          />
        </Column>
      </div>
      <Collapse isOpened={isOpen}>
        <Print obj={obj} path={path} />
      </Collapse>
    </div>
  );
};
